module.exports = __webpack_public_path__ + "static/media/yalo.92773e24.png";